<template>
  <!-- 合同续签 -->
  <div
    class="detail"
    v-if="data.header"
  >
    <!-- <ax-head v-if="options.action">
      <div slot="ing">
        <p>
          来自{{ data.header.deptid_description }}
          <em>{{ data.header.emplid_description }}</em>的
          <em>合同续签申请</em>，请您审批。
        </p>
      </div>
    </ax-head>-->
    <ax-panel :noTitle="true">
      <van-cell
        title="姓名"
        :value="data.header.emplid_description"
      ></van-cell>
      <van-cell
        title="部门"
        :value="data.header.deptid_description"
      ></van-cell>
      <van-cell
        title="员工类型"
        :value="getEmplClass(data.header.empl_class)"
      ></van-cell>
      <van-cell
        title="续签类型"
        :value="data.header.qh_renewal_type_description"
      ></van-cell>
    </ax-panel>
    <ax-panel title="续签前">
      <van-cell
        title="合同类型"
        v-model="data.header.qh_cnt_type_description"
      ></van-cell>
      <van-cell
        title="合同开始日期"
        v-model="data.header.contract_begin_dt"
      ></van-cell>
      <van-cell
        title="合同结束日期"
        v-model="data.header.contract_end_dt"
      ></van-cell>
      <van-cell
        title="签署类型"
        v-model="data.header.qh_cnt_sign_type_description"
      ></van-cell>
      <van-cell
        title="公司"
        v-model="data.header.company_description"
      ></van-cell>
    </ax-panel>
    <ax-panel title="续签后">
      <van-cell
        title="合同类型"
        v-model="data.qh_hr_019_hd01.qh_cnt_type_description"
      ></van-cell>
      <van-cell
        title="合同开始日期"
        v-model="data.qh_hr_019_hd01.contract_begin_dt"
      ></van-cell>
      <van-cell
        title="合同结束日期"
        v-model="data.qh_hr_019_hd01.contract_end_dt"
      ></van-cell>
      <van-cell
        title="签署类型"
        v-model="data.qh_hr_019_hd01.qh_cnt_sign_type_description"
      ></van-cell>
      <van-cell
        title="公司"
        v-model="data.qh_hr_019_hd01.company_description"
      ></van-cell>
    </ax-panel>
    <ax-panel title="续签审批说明" v-if="data.current_user!=data.header.emplid_description">
      <van-collapse
        v-model="attention"
        style="position:relative"
      >
        <van-collapse-item
          name="attention"
          style="padding-right:0.3rem;"
          value=""
          ref="item"
        >
          <p style="color: #ccc;padding-left: 25px;font-size: 0.35rem;text-align: left;color:red">为了对员工续签进行更为全面、严谨的判断，续签审批依次为直接上级进行业务判断、HRBP（当员工为M级& P3-及以上时，审批人升级为HRBP HEAD）进行HR判断、隔级上级参考前两项判断进行审批。如审批意见一致，则流程进行下一步；如审批意见不一致，由HRBP HEAD协调沟通并在系统中提交最终结果。</p>
        </van-collapse-item>
        <p
          style="color: #ccc;padding-left: 25px;font-size: 0.35rem;text-align: left;color:red;position:absolute;top:.38rem"
          @click="openIt"
        >您无需与员工沟通，后续会征询员工本人意见。</p>
      </van-collapse>
    </ax-panel>
    <!-- 如果是普通实习生 和劳务协议   并且不是本人的时候 -->
    <ax-panel
      title="审批信息"
      v-if="data.action === 'U' && data.header.emplid!== data.current_oprid && (data.header.empl_class=='03' || data.header.empl_class=='04')"
    >
    <!-- <ax-panel
      title="审批信息"
      v-if="data.action === 'U' && data.header.emplid!== data.current_oprid && (data.header.empl_class=='06' || data.header.empl_class=='03' || data.header.empl_class=='04')"
    > -->
      <ax-select
        label="审批类型"
        v-model="subData.qh_contract_yes"
        :options="data.header.empl_class=='06' ? contractValues1:contractValues"
        :class="{ 'errors_box':errors.has('qhContractYes')}"
        v-validate="'required'"
        name="qhContractYes"
      ></ax-select>
      <!-- 如果是普通实习生 -->
      <!-- <section v-if="data.header.empl_class=='06'">
        <div class="sub-text">附件上传</div>
        <van-uploader
          v-model="fileList"
          :after-read="afterRead"
          :deletable="false"
          :max-size="10 * 1024 * 1024"
        ></van-uploader>
      </section> -->
    </ax-panel>
    <!-- 如果是普通实习生  end-->
  </div>
</template>

<script>
export default {
  props: ['data', 'options'],
  data() {
    return {
      contractValues: [
        { text: '不续签,办理离职手续', id: 'A' },
        { text: '已和OD沟通,占用其他HC，续签', id: 'B' }
      ],
      contractValues1: [
        { text: '不续签,办理离职手续', id: 'A' },
        { text: '已和OD沟通,占用其他HC，续签', id: 'B' },
        { text: '已和校招组沟通，占用校招HC，续签', id: 'C' }
      ],
      fileList: [],
      subData: {
        qh_contract_yes: '',
        filename: '',
        data: ''
      },
      attention: ['']
    };
  },
  watch: {
    'subData.qh_contract_yes'(val) {
      this.$emit('saveSubData', this.subData);
    }
  },
  mounted() {},
  methods: {
    getEmplClass(empl_class) {
      let obj = {
        '03': '临时劳务',
        '04': '兼职劳务',
        '06': '普通实习生',
        '01': '正式员工',
        '02': '派遣正式',
        '05': '校招实习生',
        '08': '暑期实习生'
      };
      return obj[empl_class] ? obj[empl_class] : '';
    },
    isOkImg(ext) {
      return ['jpg', 'png', 'pdf', 'rar'].indexOf(ext.toLowerCase()) !== -1;
    },
    async afterRead(file) {
      const index = file.file.name.lastIndexOf('.');
      const ext = file.file.name.substr(index + 1);
      if (!file) {
        this.subData.filename = '';
        this.subData.data = '';
        return;
      }
      console.log('isOkImg(ext)', this.isOkImg(ext));
      if (!this.isOkImg(ext)) {
        this.$toast('文件格式仅支持：jpg、 png,、pdf、rar');
        this.fileList = [];
        return;
      }
      if (file.file.size > 10 * 1024 * 1024) {
        this.$toast('文件太大,请重新选择');
        return;
      }
      // [name].im.corp.jpg   转变成   [name].jpg
      this.subData.filename = file.file.name.replace(/\..*(\.\w+)$/, '$1');
      // base64 格式文件内容
      let base64Url = await this.fileCanvasImg(file.content, file.file.type);
      this.subData.data = base64Url.replace(/data:.*base64,/, '');
      this.fileList = [{ url: base64Url, isImage: true }];
      this.$emit('saveSubData', this.subData);
    },
    // 利用canvas 压缩 文件
    fileCanvasImg(src, type) {
      type = type || 'image/png';
      return new Promise((resolve, reject) => {
        var img = new Image();
        img.src = src;
        img.onload = function (e) {
          var canvas = document.createElement('canvas');
          var context = canvas.getContext('2d');
          // 图片原始尺寸
          var originWidth = e.target.width;
          var originHeight = e.target.height;
          // canvas对图片进行缩放
          canvas.width = originWidth;
          canvas.height = originHeight;
          // 清除画布
          context.clearRect(0, 0, originWidth, originHeight);
          // 图片压缩
          context.drawImage(img, 0, 0, originWidth, originHeight);
          let url = canvas.toDataURL(type, 0.7);
          resolve(url || '');
        };
      });
    },
    openIt() {
      this.$refs.item.onClick();
    }
  }
};
</script>
<style lang="scss" scoped>
.van-cell .van-cell__value {
  text-align: right;
  padding-right: 0.6rem;
}
.van-cell {
  border-bottom: 1px solid $border-color;
}
.van-cell .van-cell__title {
  width: 4rem;
}
/deep/
  .van-collapse-item
  .van-collapse-item__wrapper
  .van-collapse-item__content {
  color: rgba(0, 0, 0, 0.9);
  padding: 0;
  padding-right: 0.2rem;
  padding-bottom: 0.4rem;
}
section {
  padding: 0 10px;
}
.top-item .sub-title {
  padding-top: 10px;
}
.sub-title {
  color: #222;
  font-size: 0.36rem;
}
.con {
  padding: 0.24rem;
  line-height: 1.4;
  color: #666;
}
.sub-text {
  margin: 0;
  padding: 4px 0;
  color: #aaa;
  font-weight: normal;
  font-size: 0.37333rem;
  line-height: 0.64rem;
}
</style>